import { render, staticRenderFns } from "./lawStampDuty.vue?vue&type=template&id=09b8e222&"
import script from "./lawStampDuty.vue?vue&type=script&lang=js&"
export * from "./lawStampDuty.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports